export default __webpack_public_path__ + "static/media/payment-turkcell.9335d628.svg";